import { Components } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Grid(): Components {
  return {
    MuiGrid: {
      styleOverrides: {}
    }
  };
}
